var _rect, _rect2, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "flags / AT"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    x: 0.25,
    y: 0.916992,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23455_16507",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Mask_2",
    x: 0.25,
    y: 0.916992,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23455_16507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.33366H32V0.666992H0V7.33366Z",
    fill: "#F64253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.6667H32V14H0V20.6667Z",
    fill: "#F64253"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/AT.79cb241cb1b78dad02db7a72d61897ba.svg";
export { ForwardRef as ReactComponent };